import $ from 'jquery'
window.$ = window.jQuery = require('jquery');
require('chosen-js')
require('jquery-ui-dist/jquery-ui')


